module.exports = __webpack_public_path__ + "img/account--icon.5029de83.svg";